class LoginForm {
  constructor(el) {
    this.form = el;
    this.email_field = el.querySelector('input[type="email"]');
    if (this.email_field) {
      this.email_field.addEventListener('input', this.checkState.bind(this));
      this.email_field.addEventListener('input', () => this.form.classList.remove('invitationFailed'));
    }

    // might be a normal login form: we just check that email and password seem ok
    this.password_field = el.querySelector('input[type="password"]');
    if (this.password_field) {
      this.password_field.addEventListener('input', this.checkState.bind(this));
    }

    // might be an invitation form: we check email and send request to trigger invitation
    this.invite_button = el.querySelector('button.inviteme');
    if (this.invite_button) {
      this.invite_button.addEventListener('click', this.inviteMe.bind(this));
    }

    this.notifier = el.querySelector('.messages');
    this.checkState();
  }

  checkState() {
    this.emailable = this.sane_email;
    this.loginnable = this.sane_email && this.sane_password;
  }

  inviteMe(e) {
    if (e) e.preventDefault();
    if (this.sane_email) {
      const email = this.email_field.value;
      this.form.classList.add('busy');
      fetch("/inviteme", {
        method: "POST",
        body: JSON.stringify({ email: email }),
        headers: { 'Content-Type': 'application/json' },
      })
      .then((r) => {
        if (r.ok) {
          this.invitationSent(r);
        } else {
          this.invitationFailed(r.status === 429
            ? "Too many requests from your network just now. Please wait a minute and try again."
            : "Sorry: we could not send the message. Please try again in a moment.");
        }
      })
      .catch((error) => {
        console.error(error);
        this.invitationFailed("Sorry: we could not reach the server. Please check your connection and try again.");
      });
    }
  }

  invitationFailed(message) {
    if (this.notifier) this.notifier.innerText = message;
    this.form.classList.remove('busy');
    this.form.classList.add('invitationFailed');
  }

  invitationSent(response) {
    if (this.notifier) {
      this.notifier.innerText = "Thank you. An invitation message should arrive straight away. Please check your mail and perhaps also the spam folder."
    }
    this.form.classList.remove('busy');
    this.form.classList.add('invitationSent');
  }

  resetForm(e) {
    if (e) e.preventDefault();
    this.form.classList.remove('busy', 'invitationSent', 'invitationFailed');
  }

  set emailable(value) {
    if (value) this.form.classList.add('emailable');
    else this.form.classList.remove('emailable');
  }

  set loginnable(value) {
    if (value) this.form.classList.add('loginnable');
    else this.form.classList.remove('loginnable');
  }

  get sane_email() {
    const eml = this.email_field && this.email_field.value;
    return eml && eml.length && /\S+@\S+\.\S+/.test(eml);
  }

  get sane_password() {
    // reminder or other email form: absent == sane
    if (!this.password_field) return true;
    const pw = this.password_field.value;
    return pw && pw.length >= 6;
  }
}

function loginForm(el) {
  return new LoginForm(el);
}


export default loginForm;